import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Fossil Sub Categories';
moduleConfig.singleItemTitle = 'Fossil Sub Category';
moduleConfig.url = 'fossil-sub-categories';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Enable Selected",
        value: "enabled"
    },
    {
        displayName: "Disable Selected",
        value: "disabled"
    }
];


export default moduleConfig;